import { Dispatch } from 'react'
import { ConfirmActionState } from './store/State'
import { setIsDialogOpen, ConfirmActionAction } from './store/Actions'

export default class ConfirmActionService {
  static toggleDialog(state: ConfirmActionState, dispatch: Dispatch<ConfirmActionAction>) {
    return () => {
      dispatch(setIsDialogOpen(!state.isDialogOpen))
    }
  }
}
